var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.807 3.04c-.181.079-.218.145-.437.797-.11.33-.59 1.752-1.064 3.161L9.444 9.56l-3.558.006c-3.267.006-3.564.009-3.626.043-.288.153-.35.534-.12.743.028.026 1.326.891 2.885 1.923l2.834 1.877-.2.574-1.102 3.154c-.847 2.42-.902 2.587-.893 2.705.02.302.352.498.641.38.043-.016 1.341-.915 2.887-1.996L12 17.003l2.802 1.96a269 269 0 0 0 2.874 1.998c.042.02.126.036.196.036.252 0 .448-.173.465-.412.009-.118-.047-.285-.905-2.738l-1.102-3.154-.188-.541 2.868-1.9c2.037-1.35 2.883-1.921 2.92-1.975a.5.5 0 0 0 .04-.42.5.5 0 0 0-.32-.272c-.07-.017-1.12-.024-3.596-.024h-3.497l-.847-2.519-1.064-3.16c-.233-.693-.265-.753-.444-.841a.5.5 0 0 0-.396-.002",
    clipRule: "evenodd"
  })));
};
export default SvgStarFilled;